// Deprecated. Please refrain from new usage
import React from "react";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

export const BottomLeft = (props) => {
  const style = {
    paddingTop: 8,
    paddingLeft: 16,
    paddingBottom: 8,
  };
  if (props.children) {
    return <div style={style}>{props.children}</div>;
  }
  return <div />;
};

BottomLeft.propTypes = {
  children: PropTypes.node,
};

BottomLeft.defaultProps = {
  children: null,
};

const ActionButtons = (props) => {
  const style = {
    textAlign: "right",
    display: "block",
  };
  const { t } = props;
  const gridStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderTop: "1px solid rgba(160,160,160,0.2)",
    padding: "12px",
    boxShadow: "0 -3px 5px 0 rgba(0,0,0,0.05)",
    position: "absolute",
    width: "100%",
    right: 0,
    bottom: 0,
  };
  /* Buttons prop should be an array of objects like this:
    [
      {
        text: "VIEW",
        action: () => console.log("yay!")
      },
    ]
  */
  const buttons = props.buttons.map((button) => (
    <Button onClick={button.action} key={button.text} style={{ fontWeight: "medium" }}>
      {t(button.text)}
    </Button>
  ));
  return (
    <div style={gridStyle}>
      <CardActions style={style}>
        {buttons}
        {props.bottomRight}
        <BottomLeft>{props.bottomLeft}</BottomLeft>
      </CardActions>
    </div>
  );
};

ActionButtons.propTypes = {
  bottomLeft: PropTypes.node,
  bottomRight: PropTypes.node,
  buttons: PropTypes.array,
  t: PropTypes.func.isRequired,
};

ActionButtons.defaultProps = {
  bottomLeft: null,
  bottomRight: null,
  buttons: [],
};

export default withTranslation("common")(ActionButtons);
export { ActionButtons };
